import axios from '@/libs/axios'

export default {
    fetchLogs({ commit, dispatch }, searchParams) {
        return axios.get('/logs', { params: searchParams })
    },
}
